import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./components/css/bootstrap.css";
import "./index.css";
import "./components/css/react-bootstrap-table.css";
import "./components/css/react-select.css";
import "./components/css/forms.css";
import "./components/css/tables.css";
import "./components/css/menutop.css";
import "./components/css/subcomponents.css";
import "./components/css/mobile.css";

ReactDOM.render(<App />, document.getElementById("root"));
